<template>
  <div style="position: relative">
    <v-layout wrap align-center class="mt-3">
      <v-flex xs12 sm5 class="mr-3">
        <v-text-field
          v-model="search_text"
          label="Search by Hotel Name"
          prepend-icon="mdi-magnify"
        ></v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs12 sm3 d-flex class="text-xs-center">
        <download-excel
          type="csv"
          :data="filtered_export_order_format"
          :fields="export_order_field"
          :name="
            'Hotel Order Report' +
            search_config.datetime_start +
            '_to_' +
            search_config.datetime_end +
            '.csv'
          "
        >
          <v-btn icon> <v-icon large color="black">print</v-icon>.csv </v-btn>
        </download-excel>
        <download-excel
          :data="filtered_export_order_format"
          :fields="export_order_field"
          :name="
            'Hotel Order Report' +
            search_config.datetime_start +
            '_to_' +
            search_config.datetime_end +
            '.xls'
          "
        >
          <v-btn icon> <v-icon large color="black">print</v-icon>.xls </v-btn>
        </download-excel>
      </v-flex>
    </v-layout>
    <div v-if="search_config.datetime_start" class="py-3">
      <span style="font-weight: bold">Data from</span>
      <span> {{ `${search_config.datetime_start}` }}</span>
      <span style="font-weight: bold" class="mx-1">to</span>
      <span> {{ `${search_config.datetime_end}` }}</span>
    </div>
    <v-data-table
      :headers="headers"
      :items="filtered_hotel_order_report_data"
      class="elevation-1"
      style="background-color: white; padding: 10px; border-radius: 10px"
    >
      <template slot="headerCell" slot-scope="props1">{{
        props1.header.text
      }}</template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.no }}</td>
        <td>{{ props.item.order_code }}</td>
        <td>
          {{
            moment(props.item.datetime_service_start).format(
              "DD/MM/YYYY - HH:mm"
            )
          }}
        </td>
        <td v-if="props.item.order_points.length > 0">
          <div style="font-weight: bold">
            {{ props.item.order_points[0].point_name }}
          </div>
          <div>{{ props.item.order_points[0].point_address }}</div>
        </td>
        <td v-else>-</td>
        <td v-if="props.item.order_points.length > 0">
          <div style="font-weight: bold">
            {{
              `${
                props.item.order_points[props.item.order_points.length - 1]
                  .point_name
              } `
            }}
          </div>
          <div>
            {{
              `${
                props.item.order_points[props.item.order_points.length - 1]
                  .point_address
              }`
            }}
          </div>
        </td>
        <td v-else>-</td>
        <td>
          {{
            `${props.item.order_customer.customer_first_name} ${props.item.order_customer.customer_last_name}`
          }}
        </td>
        <td>{{ props.item.payment_type }}</td>
        <td
          :style="
            props.item.status == 'Completed' ? 'color:green;' : 'color:red;'
          "
        >
          {{ props.item.status }}
        </td>
        <td>{{ props.item.admin_note }}</td>
        <td>{{ props.item.total_price }}</td>
        <td>{{ props.item.commission_price }}</td>
        <td>{{ props.item.net_price }}</td>
        <td>
          <v-btn
            icon
            v-if="
              props.item.order_points.some(
                (point) => point.order_items.length > 0
              )
            "
            @click="showOrderItems(props.item)"
          >
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="800px" persistent scrollable>
      <v-card style="border-radius: 10px">
        <v-toolbar
          dark
          style="background-color: #fddf00; color: black"
          class="elevation-0"
        >
          <v-toolbar-title>
            <h4>Order Items - {{ selectedOrderCode }}</h4>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="height: auto" class="px-4 pt-4">
          <v-list>
            <div v-for="(point, index) in selectedOrderPoints" :key="index">
              <v-list-item v-if="point.order_items.length > 0">
                <v-layout>
                  <v-flex>
                    <div style="font-weight: bold">
                      {{ point.point_name }}
                    </div>
                    <div style="color: grey">
                      {{ point.point_address }}
                    </div>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs2>
                    <download-excel
                      type="csv"
                      :data="exportOrderItems"
                      :fields="orderItemExportFields"
                      :name="`Order Items - ${selectedOrderCode}` + '.csv'"
                    >
                      <v-btn icon>
                        <v-icon large color="black">print</v-icon>.csv
                      </v-btn>
                    </download-excel>
                  </v-flex>
                  <v-flex xs2>
                    <download-excel
                      :data="exportOrderItems"
                      :fields="orderItemExportFields"
                      :name="`Order Items - ${selectedOrderCode}` + '.xlsx'"
                    >
                      <v-btn icon>
                        <v-icon large color="black">print</v-icon>.xlsx
                      </v-btn>
                    </download-excel>
                  </v-flex>
                </v-layout>
                <v-data-table
                  :headers="orderItemHeaders"
                  :items="point.order_items"
                  class="elevation-1"
                  style="
                    background-color: white;
                    padding: 10px;
                    border-radius: 10px;
                  "
                >
                  <template slot="headerCell" slot-scope="props1">{{
                    props1.header.text
                  }}</template>
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.item_name_th }}</td>
                    <td>{{ props.item.item_amount }}</td>
                    <td>{{ props.item.item_price }}</td>
                    <td>{{ props.item.item_total_price }}</td>
                    <td>
                      <div
                        v-for="option in parseOptions(props.item.item_option)"
                        :key="option.option_id"
                      >
                        <div>{{ option.option_name_th }}</div>
                        <div
                          v-for="choice in option.option_choice"
                          :key="choice.choice_id"
                        >
                          - {{ choice.choice_name_th }} ({{
                            choice.choice_price
                          }})
                        </div>
                      </div>
                    </td>
                  </template>
                </v-data-table>
              </v-list-item>
            </div>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      search_text: "",
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "no",
        },
        { text: "Order Code", value: "order_code", sortable: false },
        {
          text: "Date/Time",
          value: "order_time_start",
          align: "center",
          sortable: false,
        },
        { text: "Point Start", value: "order_store", sortable: false },
        { text: "Point End", value: "order_store", sortable: false },
        {
          text: "Customer",
          value: "order_customer_full_name",
          sortable: false,
        },
        {
          text: "Payment type",
          value: "order_payment",
          sortable: false,
        },
        { text: "Status", value: "order_status", sortable: false },
        { text: "Remark", value: "order_note", sortable: false },
        { text: "Total Price", value: "total_price", sortable: false },
        {
          text: "Commission Price",
          value: "commission_price",
          sortable: false,
        },
        { text: "Net Price", value: "net_price", sortable: false },
      ],
      export_order_field: {
        No: "no",
        "Order Code": "order_code",
        "Date/Time": "order_time_start",
        "Point Start": "order_point_start",
        "Point End": "order_point_end",
        Customer: "order_customer_full_name",
        "Payment type": "order_payment",
        Status: "order_status",
        Remark: "order_note",
        "Total Price": "total_price",
        "Commission Price": "commission_price",
        "Net Price": "net_price",
      },
      dialog: false,
      selectedOrderPoints: [],
      selectedOrderCode: "",
      orderItemHeaders: [
        { text: "Item Name", value: "item_name_th", sortable: false },
        { text: "Amount", value: "item_amount", sortable: false },
        { text: "Price", value: "item_price", sortable: false },
        { text: "Total Price", value: "item_total_price", sortable: false },
        { text: "Options", value: "item_option", sortable: false },
      ],
      orderItemExportFields: {
        "Item Name": "item_name_th",
        Amount: "item_amount",
        Price: "item_price",
        "Total Price": "item_total_price",
        Options: "item_option",
      },
    };
  },
  watch: {},
  computed: {
    ...mapState({
      hotel_order_report_data: (state) =>
        state.hotelReport.hotel_order_report_data,
      search_config: (state) => state.hotelReport.clone_config_path,
    }),
    filtered_hotel_order_report_data() {
      return this.hotel_order_report_data.filter((item) =>
        item.order_points.some((point) =>
          point.point_name
            .toLowerCase()
            .includes(this.search_text.toLowerCase())
        )
      );
    },
    filtered_export_order_format() {
      return this.filtered_hotel_order_report_data.map((item, index) => ({
        no: index + 1,
        order_code: item.order_code,
        order_time_start: moment(item.datetime_service_start).format(
          "DD/MM/YYYY - HH:mm"
        ),
        order_point_start:
          item.order_points.length > 0
            ? item.order_points[0].point_name +
              " - " +
              item.order_points[0].point_address
            : "-",
        order_point_end:
          item.order_points.length > 0
            ? item.order_points[item.order_points.length - 1].point_name +
              " - " +
              item.order_points[item.order_points.length - 1].point_address
            : "-",
        order_customer_full_name: `${item.order_customer.customer_first_name} ${item.order_customer.customer_last_name}`,
        order_payment: item.payment_type,
        order_status: item.status,
        order_note: item.admin_note,
        total_price: item.total_price,
        commission_price: item.commission_price,
        net_price: item.net_price,
      }));
    },
    exportOrderItems() {
      return this.selectedOrderPoints.flatMap((point) => point.order_items);
    },
  },
  methods: {
    showOrderItems(order) {
      this.selectedOrderPoints = order.order_points;
      this.selectedOrderCode = order.order_code;
      this.dialog = true;
    },
    parseOptions(options) {
      try {
        return JSON.parse(options);
      } catch (e) {
        return [];
      }
    },
  },
  created() {},
};
</script>
<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}
</style>
